export const objectsData = [
  [
    "fig_person",
    669504,
    640
  ],
  [
    "fig_chair",
    75210,
    563
  ],
  [
    "fig_bottle",
    43798,
    488
  ],
  [
    "fig_car",
    36667,
    412
  ],
  [
    "fig_cup",
    36377,
    499
  ],
  [
    "fig_book",
    30277,
    408
  ],
  [
    "fig_tie",
    24644,
    531
  ],
  [
    "fig_potted_plant",
    23880,
    396
  ],
  [
    "fig_dining_table",
    21496,
    454
  ],
  [
    "fig_tv",
    16634,
    450
  ],
  [
    "fig_bowl",
    15444,
    391
  ],
  [
    "fig_couch",
    15216,
    355
  ],
  [
    "fig_bed",
    10300,
    404
  ],
  [
    "fig_laptop",
    10166,
    407
  ],
  [
    "fig_wine_glass",
    9602,
    312
  ],
  [
    "fig_cell_phone",
    9162,
    502
  ],
  [
    "fig_vase",
    8062,
    412
  ],
  [
    "fig_bench",
    6940,
    375
  ],
  [
    "fig_truck",
    5330,
    246
  ],
  [
    "fig_dog",
    5193,
    417
  ],
  [
    "fig_refrigerator",
    4937,
    302
  ],
  [
    "fig_handbag",
    4642,
    401
  ],
  [
    "fig_clock",
    4315,
    365
  ],
  [
    "fig_bird",
    4138,
    357
  ],
  [
    "fig_traffic_light",
    4135,
    435
  ],
  [
    "fig_keyboard",
    3449,
    193
  ],
  [
    "fig_suitcase",
    3407,
    324
  ],
  [
    "fig_bicycle",
    3188,
    166
  ],
  [
    "fig_cat",
    3023,
    386
  ],
  [
    "fig_remote",
    2936,
    407
  ],
  [
    "fig_sports_ball",
    2884,
    295
  ],
  [
    "fig_oven",
    2702,
    217
  ],
  [
    "fig_backpack",
    2690,
    295
  ],
  [
    "fig_sink",
    2568,
    231
  ],
  [
    "fig_umbrella",
    2499,
    361
  ],
  [
    "fig_train",
    2481,
    284
  ],
  [
    "fig_boat",
    2444,
    181
  ],
  [
    "fig_mouse",
    2362,
    170
  ],
  [
    "fig_bus",
    2214,
    196
  ],
  [
    "fig_apple",
    2161,
    155
  ],
  [
    "fig_kite",
    2138,
    185
  ],
  [
    "fig_teddy_bear",
    2093,
    213
  ],
  [
    "fig_microwave",
    2025,
    211
  ],
  [
    "fig_cake",
    1969,
    260
  ],
  [
    "fig_toilet",
    1637,
    248
  ],
  [
    "fig_motorcycle",
    1479,
    149
  ],
  [
    "fig_horse",
    1466,
    247
  ],
  [
    "fig_surfboard",
    1399,
    221
  ],
  [
    "fig_donut",
    1313,
    238
  ],
  [
    "fig_frisbee",
    1304,
    255
  ],
  [
    "fig_airplane",
    1299,
    195
  ],
  [
    "fig_cow",
    1292,
    171
  ],
  [
    "fig_knife",
    1213,
    196
  ],
  [
    "fig_skateboard",
    1037,
    241
  ],
  [
    "fig_orange",
    1006,
    105
  ],
  [
    "fig_pizza",
    996,
    174
  ],
  [
    "fig_banana",
    900,
    172
  ],
  [
    "fig_baseball_bat",
    875,
    170
  ],
  [
    "fig_toothbrush",
    847,
    228
  ],
  [
    "fig_sheep",
    791,
    97
  ],
  [
    "fig_spoon",
    779,
    127
  ],
  [
    "fig_bear",
    668,
    140
  ],
  [
    "fig_elephant",
    659,
    170
  ],
  [
    "fig_meta00",
    652,
    652
  ],
  [
    "fig_fire_hydrant",
    499,
    154
  ],
  [
    "fig_scissors",
    427,
    148
  ],
  [
    "fig_tennis_racket",
    425,
    131
  ],
  [
    "fig_snowboard",
    423,
    88
  ],
  [
    "fig_carrot",
    385,
    78
  ],
  [
    "fig_stop_sign",
    374,
    99
  ],
  [
    "fig_hot_dog",
    331,
    105
  ],
  [
    "fig_parking_meter",
    253,
    91
  ],
  [
    "fig_fork",
    247,
    68
  ],
  [
    "fig_sandwich",
    245,
    82
  ],
  [
    "fig_giraffe",
    235,
    71
  ],
  [
    "fig_baseball_glove",
    209,
    98
  ],
  [
    "fig_broccoli",
    205,
    43
  ],
  [
    "fig_skis",
    181,
    52
  ],
  [
    "fig_zebra",
    145,
    43
  ],
  [
    "fig_toaster",
    43,
    19
  ],
  [
    "fig_hair_drier",
    17,
    5
  ]
]